import { InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useQuery } from "@tanstack/react-query";
import { fetchUserQualifications, fetchUserQualificationsByType } from "../../../services/api/user";
import { useParams } from "react-router-dom";
import BaseTooltip from "../../../components/ui/BaseTooltip";
import AddEquipmentModal from "../../CompleteYourProfile/components/AddEquipmentModal";

const AddEditEquipments = ({ userId, equipmentId }) => {
  const [isAddEquipmentModalOpen, setIsAddEquipmentModalOpen] = useState(false);
  const {
    data: userQualificationsData,
    isPending: isUserQualificationsApiLoading,
    error: isUserQualificationsApiError,
    refetch: refetchUserQualificationsByType,
  } = useQuery({
    queryKey: ["equipment", userId, equipmentId],
    queryFn: () => fetchUserQualificationsByType(userId, equipmentId),
    enabled: !!userId && !!equipmentId,
  });

  return (
    <div className="mt-6 border-b pb-4">
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center ">
        <h6 className="text-dark font-normal">Equipments</h6>
        <i
          className="fa-light fa-pencil text-gray-900 cursor-pointer"
          onClick={() => setIsAddEquipmentModalOpen(true)}
        ></i>
      </div>
      <div className="flex flex-wrap gap-4 mt-4 ml-4">
        {userQualificationsData?.data?.map((qualification) => (
          <BaseTooltip
            key={qualification?.id}
            placement="top"
            interactive={true}
            content={
              qualification?.url ? (
                <img
                  src={qualification.url}
                  alt="Qualification"
                  className="w-64 max-w-xs h-auto rounded shadow-lg border border-gray-300"
                />
              ) : (
                "No preview available"
              )
            }
          >
            <div className="flex items-center px-4 py-1 bg-light rounded-sm cursor-default">
              <p>{qualification?.qualificationSubType}</p>
            </div>
          </BaseTooltip>
        ))}
      </div>
      {isAddEquipmentModalOpen && (
        <AddEquipmentModal
          open={isAddEquipmentModalOpen}
          close={setIsAddEquipmentModalOpen}
          equipmentId={equipmentId}
          refetchUserQualificationsByType={refetchUserQualificationsByType}
          equipments={userQualificationsData?.data}
          targetUserId={userId}
        />
      )}
    </div>
  );
};

export default AddEditEquipments;
